import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Promotion/api/Categories?Take=1000&Skip=0").then(r => {
        commit("setList", r.data.data);
      });
    },

    createRegularDiscount({ commit, dispatch }, model) {
      return ajax.post("Promotion/api/Regular", model).then(r => {});
    },
    createFestivalDiscount({ commit, dispatch }, model) {
      return ajax.post("Promotion/api/Festivals", model).then(r => {});
    },
    createScheduleDiscount({ commit, dispatch }, model) {
      return ajax.post("Promotion/api/Schedule", model).then(r => {});
    },
    archiveFestival({ commit, dispatch }, model) {
      return ajax.put("Promotion/api/Festivals", model).then(r => {});
    },
    archiveRegular({ commit, dispatch }, model) {
      return ajax.put("Promotion/api/Regular", model).then(r => {});
    },
    archiveSchedule({ commit, dispatch }, model) {
      return ajax.put("Promotion/api/Schedule", model).then(r => {});
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
